
import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";
import { FloatingWhatsApp } from "@/components/FloatingWhatsApp";
import { AccessibilityButton } from "@/components/AccessibilityButton";
import { ContactHero, ContactCards, OfficeLocations } from "@/components/Contact";

export default function Contato() {
  return (
    <div className="min-h-screen bg-gray-50">
      <Header />
      <div className="pt-24">
        <ContactHero />

        <section className="py-14">
          <div className="container mx-auto px-6 max-w-3xl">
            <p className="text-xs font-bold text-gray-400 uppercase tracking-widest mb-1 text-center">Canais</p>
            <h2 className="text-2xl font-bold text-gray-800 font-primary mb-8 text-center">
              Como prefere falar?
            </h2>
            <ContactCards />
          </div>
        </section>

        <OfficeLocations />
      </div>
      <Footer />
      <FloatingWhatsApp />
      <AccessibilityButton />
    </div>
  );
}
